import { Button, Container } from "react-bootstrap";

export default function Links() {
  return (
    <>
      <Container fluid className="text-center py-3 bg-dark">
        <Button
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.instagram.com/smarmyart/"
          variant="outline-light"
          size="sm"
        >
          <strong>Instagram</strong>
        </Button>{" "}
        <Button
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.redbubble.com/people/mgerhold/shop"
          variant="outline-light"
          size="sm"
        >
          <strong>Red Bubble</strong>
        </Button>{" "}
        <Button
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.saatchiart.com/melissagerhold"
          variant="outline-light"
          size="sm"
        >
          <strong>Saatchi Art</strong>
        </Button>{" "}
        <Button
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/melissagerhold/"
          variant="outline-light"
          size="sm"
        >
          <strong>LinkedIn</strong>
        </Button>{" "}
        <Button
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.amazon.com/stores/Melissa-Gerhold/author/B0CK9DKC41?ref=ap_rdr&isDramIntegrated=true&shoppingPortalEnabled=true"
          variant="outline-light"
          size="sm"
        >
          <strong>Amazon Books</strong>
        </Button>{" "}
        {/* <Button
          target="_blank"
          rel="noopener noreferrer"
          href="https://mediavelocity.com/"
          variant="outline-light"
          size="sm"
        >
          <strong>Mediavelocity</strong>
        </Button>{" "} */}
      </Container>
    </>
  );
}
